// ** Dropdowns Imports
import React, { useMemo } from 'react';
// ** Third Party Components
import { Menu } from 'react-feather';
import { NavItem, NavLink } from 'reactstrap';
import { Placement } from 'popper.js';
import { ShepherdTour } from 'react-shepherd';
import AlertsDropdown from '@appcomponents/molecules/AlertsDropdown';
import IntlDropdown from '@src/components/molecules/IntlDropdown';
import UserDropdown from './UserDropdown';
import { useNotifications } from '@src/@data/store/NotificationsProvider';
import { useMessages } from '@hooks/useMessages';
import 'shepherd.js/dist/css/shepherd.css';
import '@styles/react/libs/shepherd-tour/shepherd-tour.scss';
import NavCompanyCredit from '@src/components/layouts/components/navbar/NavCompanyCredit';
import { QrScannerDropdown } from '@src/components/organisms/qr-scanner/QrScannerDropdown';

interface Props {
  menuHidden?: boolean;
  setMenuVisibility?: (visible: boolean) => void;
}

const notificationTourOptions = {
  defaultStepOptions: {
    cancelIcon: {
      enabled: true,
    },
    scrollTo: false,
    arrow: true,
    modalOverlayOpeningPadding: 12,
    modalOverlayOpeningRadius: 8,
  },
  useModalOverlay: true,
};

const NavbarUser: React.FC<Props> = ({ setMenuVisibility, menuHidden }) => {
  const { requestPermission, saveAskedPermission } = useNotifications();
  const { messages } = useMessages();

  const setMenuVisible = () => {
    if (!!setMenuVisibility) {
      setMenuVisibility(true);
    }
  };

  const notificationSteps: React.ComponentProps<typeof ShepherdTour>['steps'] =
    useMemo(
      () => [
        {
          id: 'show-permission',
          attachTo: { element: '#alerts-dropdown', on: 'bottom' as Placement },
          buttons: [
            {
              classes: 'btn btn-sm btn-outline-primary',
              text: messages('notifications_permission_popup_cta'),
              action() {
                requestPermission();
                this.complete();
              },
            },
          ],
          title: messages('notifications_permission_popup_title'),
          text: [messages('notifications_permission_popup')],
          when: {
            cancel: saveAskedPermission,
          },
        },
      ],
      [messages, requestPermission, saveAskedPermission]
    );

  return (
    <>
      {!menuHidden && (
        <ul className="navbar-nav d-xl-none d-flex align-items-center">
          <NavItem className="mobile-menu mr-auto">
            <NavLink
              className="nav-menu-main menu-toggle hidden-xs is-active"
              onClick={setMenuVisible}
            >
              <Menu className="ficon" />
            </NavLink>
          </NavItem>
        </ul>
      )}
      <ul className="navbar-nav d-flex w-100 justify-content-end align-items-center">
        <NavCompanyCredit className="mr-auto" />
        <ShepherdTour
          steps={notificationSteps}
          tourOptions={notificationTourOptions}
        >
          <AlertsDropdown />
        </ShepherdTour>
        <QrScannerDropdown />
        <IntlDropdown />
        <UserDropdown />
      </ul>
    </>
  );
};
export default NavbarUser;
